export default __webpack_public_path__ + "static/media/NetflixLogo.f4070143.png";